<template>
  <div class="size-guide-page critical-component-clear grid">
    <h1
      class="size-guide-page__title"
      :class="colClasses"
      v-text="liquid.title"
    />

    <p
      class="size-guide-page__copy text-body-2xs-regular"
      :class="colClasses"
      v-html="copy"
    />

    <ul
      class="size-guide-page__view-toggle"
      :class="colClasses"
    >
      <li>
        <btn
          class="size-guide-page__view-toggle-button"
          modifiers="primary outline block center"
          :class="{
            'active': currentView === 'sizes',
          }"
          label-class="text-body-2xs-regular"
          :label="$string('product.size_guide.size_guide')"
          @focus="setCurrentView('sizes')"
          @click="setCurrentView('sizes')"
        />
      </li>

      <li>
        <btn
          class="size-guide-page__view-toggle-button"
          :class="{
            'active': currentView === 'conversion',
          }"
          modifiers="primary outline block center"
          label-class="text-body-2xs-regular"
          :label="$string('product.size_guide.size_conversion')"
          @focus="setCurrentView('conversion')"
          @click="setCurrentView('conversion')"
        />
      </li>
    </ul>

    <div
      class="size-guide-page__chart"
      :class="colClasses"
    >
      <size-guide
        :is-conversion-guide="currentView === 'sizes'"
        :conversion-guide="liquid?.internationalConversionGuide"
        :iso-code="liquid?.isoCode"
      />
    </div>

    <div
      id="how-to-measure"
      class="size-guide-page__how-to-measure"
      :class="colClasses"
    >
      <how-to-measure
        :copy="liquid?.howToMeasureCopy"
        :image="liquid?.howToMeasureImage"
      />
    </div>

    <div
      v-if="liquid?.contactUs"
      class="size-guide-page__contact-us"
      :class="colClasses"
    >
      <h2
        v-if="liquid?.contactUsTitle"
        class="size-guide-page__contact-us-title"
        v-text="liquid?.contactUsTitle"
      />

      <div
        v-if="liquid?.contactUsCopy"
        class="size-guide-page__contact-us-copy"
        v-html="liquid?.contactUsCopy"
      />
    </div>
  </div>
</template>

<script>

/**
 * Vue: Size guide page (size-guide-page)
 * -----------------------------------------------------------------------------
 * Size guide page.
 *
 * @param {String} liquid.sectionId - Section's Liquid ID.
 *
 */
import Btn from '~global/btn/btn'
import HowToMeasure from '~async/how-to-measure/how-to-measure'
import SizeGuide from '~global/size-guide/size-guide'

export default {
  name: 'SizeGuidePage',

  components: {
    Btn,
    HowToMeasure,
    SizeGuide,
  },

  props: {
    liquid: {
      type: Object,
      default: () => ({
        sectionId: '',
        title: '',
      }),
    },
  },

  data() {
    return {
      colClasses: 'col xs-span m-span l15-50',
      currentView: 'sizes',
    }
  },

  computed: {

    /**
     * Compute copy for the top of the page to link to how to measure
     * @returns {String}
     */
    copy() {
      const copy = this.$string('product.size_guide.size_guide_copy')
      const howToMeasureString = /how to measure/i
      const match = copy.match(howToMeasureString)

      return copy.replace(
        match,
        `<a class="text-body-2xs-underline" href="#how-to-measure">${match}</a>`,
      )
    },
  },

  methods: {

    /**
     * Set the current view
     * @param {String} view Set the current view; accepts values 'sizes'
     * and 'conversion'
     */
    setCurrentView(view) {
      this.currentView = view
    },
  },
}
</script>

<style lang="scss">
@import './size-guide-page';
</style>
